import axios from "axios"
import api from "@/store/api"
import Vue from "vue"

export const state = {
  carsNumbers: [{}],
  carsNumbersClone: [{}],
  cars: [{}],
  carsClone: [{}],
  models: [],
  modelsClone: [],
  clienti: [{}],
  clientiClone: [{}],
  deviz: [{}],
  denumire: [{}], // am creat temporar pentru campul denumire
  cod_piesa: [{}],
  devizClone: [{}],
  active_field: undefined,
  active_table: undefined,
  active_input_value: ''
}

export const mutations = {
  SET_TEMPLATES (state, {key, value}) {
    Vue.set(state, key, value);
    Vue.set(state, `${key}Clone`, value);
    const denumire = value.filter(o => o.denumire)
    Vue.set(state, `denumire`, denumire);
  },
  SET_CODURI_PIESE (state, value) {
    const coduri = value
      .filter(o => o.type === 'cod_piesa' && o.cod_piesa)
    Vue.set(state, 'cod_piesa', coduri);
  },
  SET_ACTIVE_FIELD (state, field) {
    Vue.set(state, 'active_field', field);
  },
  SET_ACTIVE_TABLE (state, table) {
    Vue.set(state, 'active_table', table);
  },
  SET_ACTIVE_INPUT_FIELD_VALUE (state, value) {
    Vue.set(state, 'active_input_value', value);
  },
  FILTER_CAR_NUMBER (state, string) {
    const filtered = state.carsNumbersClone
      .filter(({numar}) => numar && numar?.toLowerCase().startsWith(string))
      .map(car => car)
    Vue.set(state, 'carsNumbers', filtered)
  },
  FILTER_CAR_BRAND (state, string) {
    const filtered = state.carsClone
      .filter(car => car.brand?.toLowerCase().startsWith(string))
      .map(car => car)
    Vue.set(state, 'cars', filtered)
  },
  FILTER_CAR_MODEL (state, string) {
    const model = state.modelsClone
      .filter(model => model?.toLowerCase().startsWith(string))
    Vue.set(state, 'models', model)
  },
  FILTER_DEVIZ_FIELD (state, string) {
    const deviz = state.devizClone
      .filter(deviz => deviz && deviz.denumire && deviz.denumire.toLowerCase().startsWith(string.toLowerCase()))
    Vue.set(state, 'deviz', deviz)
  },
  SET_CARS_MODELS (state, value) {
    const models = state.carsClone
      .filter(({brand}) => brand === value)
      .flatMap(({models}) => models)
    Vue.set(state, 'models', models)
    Vue.set(state, 'modelsClone', models)
  },
  DELETE_CAR_NUMBER (state, id) {
    const filtered = state.carsNumbers.filter(car => car._id !== id)
    Vue.set(state, 'carsNumbers', filtered)
    Vue.set(state, 'carsNumbersClone', filtered)
  }
}

export const actions = {

  async get_cars_numbers_templates ({state, commit}, search = '') {
    try {
      const { data } = await axios(`${api.cars}${search ? `?search=${search}` : ''}`);
      commit('SET_TEMPLATES', { key: 'carsNumbers', value: data });
    } catch (e) {
      state.error = 'Eroare cars numbers templates'
    }
  },

  async get_cars_templates ({state, commit}) {
    try {
      const {data: value} = await axios(`${api.templates}/cars`);
      commit('SET_TEMPLATES', {key: 'cars', value})
    } catch (e) {
      state.error = 'Eroare cars templates'
    }
  },

  async get_deviz_templates ({state, commit}) {
    try {
      const { data } = await axios(`${api.templates}/deviz`)
      // remove duplicates of denumire
      const seen = new Set();
      const value = data
        .filter(o => o.denumire)
        .filter(item => {
          const duplicate = seen.has(item.denumire);
          seen.add(item.denumire);
          return !duplicate;
        });
      commit('SET_TEMPLATES', { key: 'deviz', value });
      commit('SET_CODURI_PIESE', value);
    } catch (e) {
      state.error = 'Eroare cars templates'
    }
  },
  
  async update_car_number_details ({state}, payload) {
    try {
      const id = payload._id;
      delete payload.id;

      const { data } = await axios.put(`${api.cars}/${id}`, payload);
      return data || true
    } catch (e) {
      state.error = 'Eroare cars templates'
      return false
    }
  },

  async delete_car_number ({ state, commit }, id) {
    try {
      await axios.delete(`${api.cars}/${id}`)
      commit('DELETE_CAR_NUMBER', id)
    } catch (e) {
      state.error = 'Eroare cars templates'
    }
  },

  async create_car_number (_ctx, car) {
    try {
      const { data } = await axios.post(api.cars, car)
      return data
    } catch (e) {
      this._vm?.$toast?.error?.('Nu s-a putut salva mașina. Încearcă din nou.')
      return false
    }
  }
}

export const getters = {
  numar: (state) => {
    return state.carsNumbers.filter(({numar}) => numar).map(({numar}) => numar)
  },
  marca: (state) => {
    return state.cars.map(car => car.brand).sort()
  },
  model: (state) => {
    return state.models
  },
  deviz: (state) => {
    return state.deviz.map(({denumire}) => denumire)
  },
  autocomplete_list: (state) => {
    const field = state.active_field;
    let list = state[field];
    if (!list) return [];

    if (state.active_table === 'manopera') {
      list = list.filter(o => o.manopera === true);
    } else if (state.active_table === 'parts') {
      list = list.filter(o => o.manopera !== true);
    }

    if (!state.active_input_value) return list;

    return list.filter(o => o[field]?.toLowerCase().includes(state.active_input_value.toLowerCase()));
  }
}
